import { loadTheme, OurBrands } from '@sial/common-design'
import { getBrandIdentity } from '@src/utils/getBrandIdentity'

const brandIdentity = getBrandIdentity()

export const theme = loadTheme(OurBrands[brandIdentity])
